import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-business-wise-discount-price-edit-diaglog',
  templateUrl: './business-wise-discount-price-edit-diaglog.component.html',
  styleUrls: ['./business-wise-discount-price-edit-diaglog.component.scss']
})
export class BusinessWiseDiscountPriceEditDiaglogComponent {
  discount_price: number = null;
  product_id: number = null;
  product_name: string = null;
  business_id: number = null;
  business_name: string = null;
  products = {};
  business_types = {};

  constructor(
    public dialogRef: MatDialogRef<BusinessWiseDiscountPriceEditDiaglogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private http: HttpService, private global: GlobalService) {
    console.log(data);
    this.discount_price = data['discount_price'];
  }

  updateDiscountPrice(discount_price) {
    const discount_price_data = {
      product_id: this.data['product_id'],
      business_id: this.data['business_id'],
      discount_price: discount_price,
    };
    this.http.saveOrUpdateBusinessWiseProductDiscountPrice(discount_price_data).subscribe((res_data) => {
      console.log(res_data);
      this.global.showSnakeBar('Discount price updated successfully!');
      this.closeComponent(discount_price_data);
    }, (error) => {
      console.log(error);
    });
  }

  removeCalled() {
    if (confirm('Are you sure to remove this product')) {
      const discount_price_data = {
        product_id: this.data['product_id'],
        business_id: this.data['business_id'],
        discount_price: this.discount_price,
      };
      console.log(discount_price_data);
      this.http.removeBusinessWiseProductDiscountPrice(discount_price_data).subscribe((res_data) => {
        console.log(res_data);
        this.global.showSnakeBar('Discount price updated successfully!');
        this.closeComponent(discount_price_data);
      }, (error) => {
        console.log(error);
      });
    }
  }

  closeComponent(data: any) {
    this.dialogRef.close(data);
  }
}

interface DialogData {
  product_id: number;
  business_id: number;
  business_name: string;
  discount_price: number;
}
